import { useSelector } from 'react-redux';
import { AuthEntity } from '_entities';

const { getUserSubdomain } = AuthEntity.selectors;

function IsFlAccount() {
  const userState = useSelector(getUserSubdomain);
  const floridaAccountStates = ['fl', 'florida'];
  return floridaAccountStates.includes(userState);
}

export default IsFlAccount;
